import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';
import {
    InvoiceEntityTableName,
    ModelByInvoiceEntityTable,
    PreparedDataOnInvoiceAdd,
    RecordByInvoiceEntityTable,
} from '../../../../types/Invoice';

const toPreparedDataItems = <K extends InvoiceEntityTableName>(
    records: ModelByInvoiceEntityTable[K][],
    table: K,
    operation: ValidationOperation,
): PreparedDataOnInvoiceAdd[] => {
    return records.map((record) => ({
        record,
        table,
        operation,
    })) as PreparedDataOnInvoiceAdd[];
};

const mapRawRecord = <K extends InvoiceEntityTableName>(
    record: ModelByInvoiceEntityTable[K],
) => {
    return record._raw as unknown as RecordByInvoiceEntityTable[K];
};

const addRelatedDataBatch = async (data: Model[], database: Database) => {
    await database.batch(...data);
};

export { toPreparedDataItems, addRelatedDataBatch, mapRawRecord };
